import { type FunctionComponent } from "react";

import { AbstractField, type AbstractFieldProps } from "./AbstractField";

export type NumberFieldProps = Omit<
  AbstractFieldProps,
  "type" | "render" | "children"
>;

export const NumberField: FunctionComponent<NumberFieldProps> = ({
  ...fieldProps
}) => <AbstractField type="number" {...fieldProps} />;
